import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { AddConnectionDialogComponent } from './add-connection-dialog/add-connection-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatPaginator } from '@angular/material/paginator';
import { StorageserviceService } from '../../core/services/storageservice.service';
import { AddContactDialogComponent } from './add-contact-dialog/add-contact-dialog.component';
import { AuthService } from '../../core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { UserService } from '../../core/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { ShareDocumentsDialogComponent } from './share-documents-dialog/share-documents-dialog.component';
import { ShareconfirmationdialogComponent } from '../documents/shareconfirmationdialog/shareconfirmationdialog.component';
import { DoctypePipe } from 'src/app/core/services/doctype.pipe';

interface Document {
  id: string;
  name: string;
  category: string[];
  documentType?: string;
  documentId?: string;
  uploadDate: Date;
  expirationDate?: Date;
  description: string;
  fileSize: string;
  tags: string[];
  thumbnail?: string;
  fileData?: File;
  fileDataUrl?: string;
  previewUrl?: SafeUrl;
  mimeType?: string;
  uploadProgress?: number;
}

interface DocumentCategory {
  id: string;
  title: string;
  count: number;
  image: any;
  isActive: boolean;
  documentTypes?: string[];
}

@Component({
    selector: 'app-connections',
    templateUrl: './connections.component.html',
    styleUrls: ['./connections.component.css'],
    standalone: false
})

export class ConnectionsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  sortBy: string = 'name';
  searchQuery: string = '';
  searchRel: string = '';
  displayedColumns: string[] = [
    'name',
    'description',
    'uploadedOn',
    'expiringOn',
    'tags',
    'actions'
  ];

  sortContacts = [
    { label: 'Sort by Name', icon: 'sort_by_alpha', action: () => this.onSortContacts('name') },
    { label: 'Sort by Email', icon: 'date_range', action: () => this.onSortContacts('email') },
  ];

  sortConnections = [
    { label: 'Sort by Name', icon: 'sort_by_alpha', action: () => this.onSortConnections('business_name') },
    { label: 'Sort by Email', icon: 'date_range', action: () => this.onSortConnections('email') },
    { label: 'Old to New', icon: 'arrow_upward', action: () => this.sortByDate('old to new') },
    { label: 'New to Old', icon: 'arrow_downward', action: () => this.sortByDate('new to old') },
  ];

  dropdownOptions = [
    { label: 'Connection', icon: 'fa fa-user-plus', iconType: 'fa', action: this.onAddConnection.bind(this) },
    { label: 'Contact', icon: 'fa fa-address-card', iconType: 'fa', action: this.onAddContact.bind(this) },
  ];

  connectionKey = false;
  profileKey = false;
  documents: Document[] = [];
  private allDocuments: Document[] = [];
  pageSize = 10;
  currentPage = 0;
  totalDocuments = 0;

  documentCategories: DocumentCategory[] = [
    { id: 'personal', title: 'Personal', count: 0, image: 'assets/images/personalConn.svg', isActive: false },
    { id: 'legal', title: 'Legal & Finance', count: 0, image: 'assets/images/legalConn.svg', isActive: false },
    { id: 'finance', title: 'Others', count: 0, image: 'assets/images/financeConn.svg', isActive: false }
  ];

  documentCategoryDialog: DocumentCategory[] = [
    { id: 'identity', title: 'Ldentity', count: 0, image: 'assets/images/identityConn.svg', isActive: true },
    { id: 'personal', title: 'Personal', count: 0, image: 'assets/images/personalConn.svg', isActive: true },
    { id: 'health', title: 'Health', count: 0, image: 'assets/images/healthConn.svg', isActive: false },
    { id: 'legal', title: 'Legal', count: 0, image: 'assets/images/legalConn.svg', isActive: false },
    { id: 'finance', title: 'LegalFinance', count: 0, image: 'assets/images/financeConn.svg', isActive: false },
    { id: 'others', title: 'Others', count: 0, image: 'assets/images/othersConn.svg', isActive: false }
  ];

  previewDocument: Document | null = null;
  isPreviewOpen = false;
  isPreviewLoading = false;

  menu_list: any[] = [];
  selected_tag = "Personal";
  list: any = [];
  isClassExpand = false;
  expandclick = false;
  searchText = '';
  searchTextSecond: any;

  doctypeMap: { [key: string]: string } = {
    driver_license: 'Driver\'s Licence',
    aadhar: 'AADHAR Card',
    pancard: 'PAN Card',
    passport: 'Passport',
    voterid: 'Voter ID',
    nic: 'National Identity Card',
    ssc: 'Social Security Card',
    tfn: 'Tax Filing Number',
    nino: 'National Insurance Number',
    nhsn: 'National Health Service Number',
    pio: 'PIO (Person of Indian Origin)',
    oci: 'OCI (Overseas Citizen of India)',
    sic: "Social Insurance Card",
    cpf: 'Cadastro de Pessoas Físicas (CPF)',
    birth_number: 'Birth Number',
    cvr_number: 'CVR Number',
    vat_number: 'VAT Registration Number',
    hetu: 'Personal Identification Number',
    hic: 'Health Insurance Card',
    nhi: 'National Health Index Number',
    tin: 'Tax Identification Number',
    pesel_number: 'PESEL Number',
    regon: 'REGON - Identification for Business',
    hun: 'Health User Number',
    ic_number: 'Civil Identification Number',
    nie: 'NIE (Foreigner Identification Number)',
    con: 'Co-Ordination Number',
    orn: 'Organisation Number',
  };

  searchbar = 'searchbar';
  relationship_list_data: any;
  entity_list: any[] = [];
  doc_list: any;
  type_con = "";
  url = "";
  status: any;
  share_id: any;
  allowedFileTypes = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/rtf',
    'text/csv',
    'text/rtf'
  ];
  searchTimeout: any;
  showDetails = false;
  profileData: any;
  profileImg: string = '';
  selectedProfile: any;
  tab = 'with';
  viewMode: 'list' | 'grid' = 'grid';

  selectedCountry: any;
  countryCodeMap: { [key: string]: string } = {
    "Argentina": "ar",
    "Australia": "au",
    "Austria": "at",
    "Belgium": "be",
    "Bosnia": "ba",
    "Brazil": "br",
    "Bulgaria": "bg",
    "Canada": "ca",
    "Chile": "cl",
    "China": "cn",
    "Croatia": "hr",
    "Czech Republic": "cz",
    "Denmark": "dk",
    "Estonia": "ee",
    "Finland": "fi",
    "France": "fr",
    "Germany": "de",
    "Herzegovina": "ba",
    "Iceland": "is",
    "India": "in",
    "Indonesia": "id",
    "Israel": "il",
    "Italy": "it",
    "Latvia": "lv",
    "Lithuania": "lt",
    "Macedonia": "mk",
    "Malaysia": "my",
    "Mexico": "mx",
    "Moldova": "md",
    "Montenegro": "me",
    "Netherlands": "nl",
    "New Zealand": "nz",
    "Norway": "no",
    "Poland": "pl",
    "Portugal": "pt",
    "Romania": "ro",
    "Serbia": "rs",
    "Singapore": "sg",
    "Slovakia": "sk",
    "Slovenia": "si",
    "South Africa": "za",
    "South Korea": "kr",
    "Spain": "es",
    "Sweden": "se",
    "Switzerland": "ch",
    "Turkey": "tr",
    "Ukraine": "ua",
    "United Arab Emirates": "ae",
    "United Kingdom": "gb",
    "United States": "us",
    "USA": "us"
  };
  citizen: any[] = [];
  country: any;

  activeTab: 'by' | 'with' = 'by';
  filesSharedWith: any[] = [];
  filesSharedBy: any[] = [];
  selectedCategoryTitle: any;
  sortDirection: { [key: string]: 'asc' | 'desc' } = {};

  readonly IMAGE_MIME_TYPES = new Set([
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/bmp',
    'image/tiff',
    'image/x-icon'
  ]);

  isImage(mimeType: any): any {
    return this.IMAGE_MIME_TYPES.has(mimeType);
  }

  readonly VIDEO_MIME_TYPES = new Set([
    'video/mp4'
  ]);

  isVideo(mimeType: any): any {
    return this.VIDEO_MIME_TYPES.has(mimeType);
  }

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private userService: UserService,
    private storageService: StorageserviceService,
    private fb: FormBuilder,
    private auth: AuthService,
    private data: DataService,
    private router: Router,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {

    // Single queryParams subscription — handles accept requests AND category routing
    this.route.queryParams.subscribe(params => {
      const acceptId = params['acceptId'];
      const bizType = params['bizType'];
      if (acceptId && bizType) {
        this.acceptDashboardRequest(acceptId, bizType);
      }

      // Determine which category to activate based on query param
      const category = params['category'];
      let categoryObj: any;

      switch (category) {
        case 'personal':
          categoryObj = this.documentCategories.find(cat => cat.title === 'Personal');
          break;
        case 'others':
          categoryObj = this.documentCategories.find(cat => cat.title === 'Others');
          break;
        case 'legal':
        default:
          // Default to Legal & Finance when no category param or category=legal
          categoryObj = this.documentCategories.find(cat => cat.title === 'Legal & Finance');
          break;
      }

      if (categoryObj) {
        this.onCategoryClick(categoryObj);
      }
    });

    this.auth.service_provider_list().subscribe((res: any) => {
      // placeholder
    });

    // Update counts for each category tab
    this.documentCategories.forEach(cat => {
      let tag = cat.title.trim();
      if (tag === 'Personal') tag = 'Personal';
      if (tag === 'Legal & Finance') tag = 'Lauditor';
      if (tag === 'Others') tag = 'ContentCoffer';

      this.auth.get_relationship_bytag(tag).subscribe((res: any) => {
        if (!res.error && res.data?.relationships) {
          cat.count = res.data.relationships.length;
        } else {
          cat.count = 0;
        }
      });
    });

    this.auth.get_entity_dummy().subscribe((res: any) => {
      this.entity_list = res.relationships || [];
    });

    this.auth.get_AddressBook().subscribe((res: any) => {
      this.entity_list = res.data.contacts || [];
    });

    this.auth.relationship_list().subscribe((res: any) => {
      this.relationship_list_data = res;
    });

    this.getCitizenships();
    this.getCountries();
    this.loadFiles(this.activeTab);
  }

  refreshRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/consumer', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  getDoctypeName(doctype: string): string {
    return this.doctypeMap[doctype] || doctype;
  }

  getTags() {
    this.documentCategories.forEach(cat => {
      let tag = cat.title;
      if (tag === 'Legal & Finance') tag = 'Lauditor';
      if (tag === 'Others') tag = 'ContentCoffer';
      if (tag === 'Personal') tag = 'Personal';

      this.auth.get_relationship_bytag(tag).subscribe((res: any) => {
        this.list = res.data.relationships;
      });
    });
  }

  get files(): any[] {
    return this.activeTab === 'with' ? this.filesSharedWith : this.filesSharedBy;
  }

  loadFiles(type: 'with' | 'by') {
    this.activeTab = type;

    if (!this.selectedProfile) return;

    if (type === 'with') {
      this.auth.shared_with_me(this.selectedProfile.id).subscribe((res: any) => {
        this.filesSharedWith = res.data.documents || [];
      });
    } else if (type === 'by') {
      this.auth.shared_by_me(this.selectedProfile.id).subscribe((res: any) => {
        this.filesSharedBy = res.data.documents || [];
      });
    }
  }

  getCitizenships() {
    this.auth.get_citizenship().subscribe((user: any) => {
      // placeholder
    });
  }

  getCountries() {
    this.auth.getCountries().subscribe((res: any) => {
      this.country = res.data.country;
    });
  }

  getCountryCode(countryName: string): string {
    const name = countryName.trim();
    const code = this.countryCodeMap[name];
    return code || '';
  }

  getFlagUrl(countryName: string): string {
    const code = this.getCountryCode(countryName).toLowerCase();
    return code ? `https://flagcdn.com/${code}.svg` : '';
  }

  getDummyRel() {
    this.auth.get_AddressBook().subscribe((res: any) => { });
  }

  onCategoryClick(category: any): void {
    let title = category.title;
    localStorage.setItem('selectedCategory', title);

    if (title === 'Personal ') title = 'Personal';
    if (title === 'Legal & Finance') title = 'Lauditor';
    if (title === 'Others') title = 'ContentCoffer';

    if (title === 'Health') {
      this.list = [];
      this.documentCategories.forEach(cat => cat.isActive = false);
      category.isActive = true;
      this.connectionKey = false;
      this.profileKey = false;
      return;
    }

    this.auth.get_relationship_bytag(title).subscribe((res: any) => {
      if (!res.error) {
        this.list = res.data.relationships;
      }
    });

    this.documentCategories.forEach(cat => cat.isActive = false);
    category.isActive = true;
    this.connectionKey = false;
    this.profileKey = false;
  }

  getPersonalRel() {
    this.auth.get_relationship_bytag('Personal').subscribe((res: any) => {
      if (res.error == false) {
        this.list = res.data.relationships;
      }
    });
  }

  update_tags() {
    this.menu_list.splice(0, this.menu_list.length);
    this.menu_list = [
      { "tagName": "Key_contacts", "count": 0 },
      { "tagName": "Personal", "count": 0 },
      { "tagName": "Lauditor", "count": 0 },
      { "tagName": "ContentCoffer", "count": 0 }
    ];

    this.auth.get_relationship_tag_count().subscribe((res: any) => {
      if (res.error == false) {
        this.auth.get_AddressBook().subscribe((res: any) => {
          if (res.error == false) {
            this.menu_list.forEach(item => {
              if (item.tagName == "Key_contacts") {
                item.count = res.relationships?.length;
              }
            });
          }
        });

        this.menu_list.forEach(item => {
          res.counts.forEach((element: any) => {
            if (item.tagName == element.tagName) {
              item.count = element.count;
            }
          });
        });
      }
    });
  }

  toggleView(): void {
    this.viewMode = this.viewMode === 'list' ? 'grid' : 'list';
  }

  onSortContacts(criteria: string) {
    const current = this.sortDirection[criteria];
    const newDirection = current === 'desc' ? 'asc' : 'desc';
    this.sortDirection[criteria] = newDirection;

    const sorted = [...this.entity_list];
    sorted.sort((a, b) => {
      const valA = (a[criteria] || '').toString().toLowerCase();
      const valB = (b[criteria] || '').toString().toLowerCase();
      return newDirection === 'desc'
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });

    this.entity_list = sorted;
  }

  onSortConnections(criteria: string) {
    const current = this.sortDirection[criteria];
    const newDirection = current === 'desc' ? 'asc' : 'desc';
    this.sortDirection[criteria] = newDirection;

    const sorted = [...this.list];
    sorted.sort((a, b) => {
      const valA = (a[criteria] || '').toString().toLowerCase();
      const valB = (b[criteria] || '').toString().toLowerCase();
      return newDirection === 'desc'
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });

    this.list = sorted;
  }

  sortByDate(criteria: string): void {
    const sorted = [...this.list];
    if (criteria === 'new to old')
      sorted.sort((a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime());
    else
      sorted.sort((a: any, b: any) => new Date(a.created).getTime() - new Date(b.created).getTime());

    this.list = sorted;
  }

  formatDate(date: Date): string {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  getProfile() {
    this.auth.get_digicoffer_profile().subscribe((user: any) => {
      this.profileData = user.data.profile;
    });
    this.auth.get_image().subscribe((img: any) => {
      this.profileImg = img.data.imageUrl;
    });
  }

  addressBook() {
    this.getDummyRel();
    this.connectionKey = true;
  }

  profilePage(contact: any) {
    this.selectedProfile = contact;
    this.profileKey = true;
    this.withbySharedFiles();
    this.searchRel = '';
    this.searchQuery = '';
  }

  goBack() {
    this.connectionKey = false;
  }

  chatUnavailableMsg(contact: any): string {
    return `Chat window with Lawyer ${contact?.business_name || ''} is no longer available. Please try after some time.`;
  }

  sharingDisabledMsg(contact: any): string {
    return `Sharing documents with Lawyer ${contact?.business_name || ''} is currently disabled. Please try again after some time.`;
  }

  shareDocuments(category?: any) {
    if (this.isLawyerInactive(this.selectedProfile)) return;
    const dialogRef = this.dialog.open(ShareDocumentsDialogComponent, {
      width: '600px',
      panelClass: 'document-dialog',
      disableClose: true,
      data: {
        mode: 'add',
        defaultCategory: category || 'identity',
        categories: this.documentCategoryDialog,
        business_name: this.selectedProfile?.business_name || '',
        id: this.selectedProfile?.id || '',
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.auth.get_relationship_bytag('Lauditor').subscribe((res: any) => {
        if (res.error == false) {
          this.list = res.data.relationships;
        }
      });
      this.loadFiles(this.activeTab);
    });
  }

  onAddConnection(category?: any) {
    const dialogRef = this.dialog.open(AddConnectionDialogComponent, {
      width: '600px',
      panelClass: 'document-dialog',
      disableClose: true,
      data: {
        mode: 'add',
        defaultCategory: category || 'personal',
        categories: this.documentCategories,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.auth.get_relationship_bytag(this.selected_tag).subscribe((res: any) => {
        this.list = res.data.relationships;
      });
      this.update_tags();
      this.searchQuery = '';
    });
  }

  getReadableDocType(doctype: string): string {
    const pipe = new DoctypePipe();
    return pipe.getDocLabelByType(doctype);
  }

  unshare(file: any): void {
    if (file.doctype === 'identity')
      file.docname = this.getReadableDocType(file.docname);

    const confirmationDialogRef = this.dialog.open(ShareconfirmationdialogComponent, {
      data: {
        document: {
          name: file.docname,
          id: file.docid,
          doctype: file.docname
        },
        category: file.doctype || 'personal',
        action: 'unshare',
        person: {
          id: this.selectedProfile.id,
          name: this.selectedProfile.business_name,
          email: this.selectedProfile.email
        },
        selectedPeople: [{
          id: this.selectedProfile.id,
          name: this.selectedProfile.business_name,
          email: this.selectedProfile.email,
          selected: true,
          category: file.doctype || 'personal'
        }]
      },
      width: '500px',
      disableClose: true
    });

    confirmationDialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.executeUnshare(file);
      }
    });
  }

  private executeUnshare(file: any): void {
    let docType = file.doctype;

    if (docType === 'identity') docType = 'identity';
    else if (docType === 'personal') docType = 'personal';

    let payload = {
      "documents": [
        { "docid": file.docid, "doctype": docType }
      ]
    };

    this.auth.unshare_realtionship_document(this.selectedProfile.id, payload).subscribe({
      next: (res: any) => {
        this.toastr.success(`Document "${file.docname}" unshared with ${this.selectedProfile.business_name}`, 'Success');
        this.refreshSharedFiles();
      },
      error: (error: any) => {
        this.toastr.error(`Failed to unshare document "${file.docname}" with ${this.selectedProfile.business_name}`, 'Error');
      }
    });
  }

  private refreshSharedFiles(): void {
    if (this.activeTab === 'by') {
      this.auth.shared_by_me(this.selectedProfile.id).subscribe((res: any) => {
        this.filesSharedBy = res.data.documents || [];
      });
    } else if (this.activeTab === 'with') {
      this.auth.shared_with_me(this.selectedProfile.id).subscribe((res: any) => {
        this.filesSharedWith = res.data.documents || [];
      });
    }
  }

  withbySharedFiles(): void {
    this.auth.shared_by_me(this.selectedProfile.id).subscribe((res: any) => {
      this.filesSharedBy = res.data.documents || [];
    });

    this.auth.shared_with_me(this.selectedProfile.id).subscribe((res: any) => {
      this.filesSharedWith = res.data.documents || [];
    });
  }

  onAddContact(): void {
    const dialogRef = this.dialog.open(AddContactDialogComponent, {
      width: '500px',
      height: '500px',
      data: { existingCategories: this.documentCategories }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.auth.get_AddressBook().subscribe((res: any) => {
        this.entity_list = res.data.contacts;
      });
    });
  }

  onEditContact(contact: any): void {
    const dialogRef = this.dialog.open(AddContactDialogComponent, {
      width: '600px',
      disableClose: true,
      data: { contact }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.auth.get_AddressBook().subscribe((res: any) => {
          this.entity_list = res.data.contacts;
        });
      }
    });
  }

  onDeleteContact(contact: any): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      disableClose: true,
      data: {
        message: `Are you sure you want to delete ${contact.name} contact?`,
        sub: 'You will not be able to recover it once it is deleted.'
      },
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.auth.delete_AddressBook(contact.id).subscribe((res: any) => {
          if (!res.error) {
            this.toastr.success(res.msg || 'Contact deleted successfully');
            this.auth.get_AddressBook().subscribe((resp: any) => {
              this.entity_list = resp.data.contacts;
            });
          }
        });
      }
    });
  }

  setActiveDocument(selectedId: string): void {
    this.documentCategories = this.documentCategories.map((card) => ({
      ...card,
      isActive: card.id === selectedId,
    }));
    this.filterAndUpdateDocuments();
  }

  filterAndUpdateDocuments(): void {
    // reserved for future use
  }

  acceptRequest(id: any, biztype: any) {
    if (biztype == "consumer") {
      this.auth.care_team_accept_request(id).subscribe((res: any) => {
        if (res.error && typeof (res.msg) == "string") {
          this.toastr.error(res.msg);
        } else if (!res.error) {
          this.toastr.success(res.msg);
          this.connectionKey = false;
          this.profileKey = false;
        } else if (res.msg.description) {
          this.toastr.error(res.msg.description);
        }
      });
    } else if (biztype == "prof") {
      this.auth.entity_accept_request(id).subscribe((res: any) => {
        if (res.error && typeof (res.msg) == "string") {
          this.toastr.error(res.msg);
        } else if (!res.error) {
          this.toastr.success(res.msg);
          this.connectionKey = false;
          this.profileKey = false;
        } else if (res.msg.description) {
          this.toastr.error(res.msg.description);
        }
      });
    }

    this.connectionKey = false;
    this.profileKey = false;
    this.updateCounts();

    const personalCategory = localStorage.getItem('selectedCategory');
    if (personalCategory) {
      this.onCategoryClickAccept(personalCategory);
    }
  }

  onCategoryClickAccept(category: any): void {
    if (category === 'Personal ') category = 'Personal';
    if (category === 'Legal & Finance') category = 'Lauditor';
    if (category === 'Others') category = 'ContentCoffer';

    if (category === 'Health') {
      this.list = [];
      this.documentCategories.forEach(cat => cat.isActive = false);
      this.connectionKey = false;
      this.profileKey = false;
      return;
    }

    this.auth.get_relationship_bytag(category).subscribe((res: any) => {
      if (!res.error) {
        this.list = res.data.relationships;
      }
    });
  }

  updateCounts() {
    this.documentCategories.forEach(cat => {
      let tag = cat.title.trim();
      if (tag === 'Personal') tag = 'Personal';
      if (tag === 'Legal & Finance') tag = 'Lauditor';
      if (tag === 'Others') tag = 'ContentCoffer';

      this.auth.get_relationship_bytag(tag).subscribe((res: any) => {
        if (!res.error && res.data?.relationships) {
          cat.count = res.data.relationships.length;
        } else {
          cat.count = 0;
        }
      });
    });
  }

  acceptDashboardRequest(id: any, biztype: any) {
    let api$;

    if (biztype === 'consumer') {
      api$ = this.auth.care_team_accept_request(id);
    } else if (biztype === 'prof') {
      api$ = this.auth.entity_accept_request(id);
    } else {
      this.toastr.warning('Unknown business type');
      return;
    }

    api$.subscribe({
      next: (res: any) => {
        this.toastr.success(res?.msg || 'Request accepted successfully');
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: {},
          replaceUrl: true
        });
      },
      error: (err: any) => {
        this.toastr.error(err?.error?.msg || 'Something went wrong');
      }
    });
  }

  shareProfile(contact: any) {
    this.auth.shared_with_me(contact?.id).subscribe((res: any) => {
      this.filesSharedWith = res.data.documents || [];
    });

    if (this.activeTab === 'by') {
      this.auth.shared_by_me(contact?.id).subscribe((res: any) => {
        this.filesSharedBy = res.data.documents || [];
      });
    }
    if (this.activeTab === 'with') {
      this.auth.shared_with_me(contact?.id).subscribe((res: any) => {
        this.filesSharedWith = res.data.documents || [];
      });
    }
  }

  getshareProfile(contact?: any) {
    this.auth.shared_by_me(contact?.id).subscribe((res: any) => {
      this.filesSharedBy = res.data.documents || [];
    });
    this.auth.shared_with_me(contact?.id).subscribe((res: any) => {
      this.filesSharedWith = res.data.documents || [];
    });
  }

  chatProfile() {
    this.router.navigate(['/consumer/chats']);
  }

  // isSubActive comes from the relationship API; only an explicit false means expired.
  isLawyerInactive(contact: any): boolean {
    return contact?.isSubActive === false;
  }

  goChatConnection(event: Event, contact: any): void {
    event.stopPropagation();
    if (this.isLawyerInactive(contact)) {
      return;
    }
    this.router.navigate(['/consumer/chats'], {
      queryParams: {
        guid: contact.guid,
        type: contact.business_category
      }
    });
  }

  goShareConnection(event: Event, contact: any): void {
    event.stopPropagation();
    this.selectedProfile = contact;
    this.profileKey = true;
    this.withbySharedFiles();
  }

  toggleDetails() {
    this.showDetails = !this.showDetails;
  }

  goBacktoConnections() {
    this.profileKey = false;
    this.toggleDetails();
  }

  onDocumentAction(action: string, document: Document): void {
    switch (action) {
      case 'view':
        this.viewDocument(document);
        break;
      case 'download':
        this.downloadDocument(document);
        break;
    }
  }

  viewDocument(document: any): void {
    // Open the modal immediately with a loading state (matches documents module behavior)
    this.previewDocument = null;
    this.isPreviewOpen = true;
    this.isPreviewLoading = true;

    if (this.activeTab === 'with') {
      this.auth.get_doc_view(this.selectedProfile.id, document.docid).subscribe({
        next: (res: any) => {
          if (res.error === false) {
            if (document.added_encryption == true) {
              const body = { "docid": document.docid };
              let url = environment.cofferRestUrl + 'consumer/v3/professional/decrypt';

              this.auth.sendPostDecryptRequest(url, body).subscribe((res: any) => {
                const blob = new Blob([res], { type: document.content_type });
                const url = URL.createObjectURL(blob);
                if (this.allowedFileTypes.includes(document.content_type)) {
                  let fdata = new FormData();
                  fdata.append('file', blob);
                  this.auth.sendPostDecryptRequest(environment.DOC2FILE, fdata).subscribe((ans: any) => {
                    const ansBlob = new Blob([ans], { type: 'application/pdf' });
                    const ansUrl = URL.createObjectURL(ansBlob);
                    document.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(ansUrl);
                    document.mimeType = 'application/pdf';
                    document.name = document.docname || 'Document';
                    this.openPreview(document);
                  });
                } else {
                  document.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                  document.mimeType = document.content_type || 'application/pdf';
                  document.name = document.docname || 'Document';
                  this.openPreview(document);
                }
              });
            } else {
              if (document.content_type == 'application/pdf') {
                document.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.data?.url);
                document.mimeType = document.content_type || 'application/pdf';
                document.name = document.docname || 'Document';
                this.openPreview(document);
              } else if (this.allowedFileTypes.includes(document.content_type)) {
                const url = environment.DOC2PDF;
                setTimeout(() => {
                  this.auth.sendPostDecryptRequest(url, { url: document.url }).subscribe({
                    next: (res: any) => {
                      const blob = new Blob([res], { type: 'application/pdf' });
                      const blobUrl = URL.createObjectURL(blob);
                      document.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
                      document.mimeType = 'application/pdf';
                      document.name = document.docname || 'Document';
                      this.openPreview(document);
                    },
                    error: (err) => {
                      console.error('Error converting document:', err);
                      this.toastr.error('Failed to convert file.');
                      this.isPreviewLoading = false;
                    }
                  });
                }, 0);
              } else {
                document.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.data?.url);
                document.mimeType = document.content_type;
                document.name = document.docname || 'Document';
                this.openPreview(document);
              }
            }
          } else {
            this.toastr.error(res.msg || 'Unable to preview document.');
            this.isPreviewLoading = false;
          }
        },
        error: (err) => {
          const message = err?.error?.msg || 'Something went wrong. Please try again later.';
          this.toastr.error(message || 'Unable to preview document.');
          this.isPreviewLoading = false;
        }
      });
    } else {
      const rawUrl = typeof document.url === 'string'
        ? document.url
        : document.url.changingThisBreaksApplicationSecurity;

      document.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
      document.mimeType = document.content_type || 'application/pdf';
      document.name = document.docname || 'Document';
      this.openPreview(document);
    }
  }

  openPreview(document: Document): void {
    this.previewDocument = document;
    this.isPreviewOpen = true;
    this.isPreviewLoading = false;
  }

  downloadDocument(doc: any): void {
    if (this.activeTab === 'with') {
      if (doc.added_encryption === true) {
        const body = { docid: doc.docid };
        const url = environment.cofferRestUrl + 'consumer/v3/professional/decrypt';

        this.auth.sendPostDecryptRequest(url, body).subscribe((res: any) => {
          const blob = new Blob([res], { type: doc.content_type });
          const url = URL.createObjectURL(blob);
          const anchor = document.createElement("a");
          anchor.download = doc?.filename;
          anchor.href = url;
          this.toastr.success(res.msg || 'Document downloaded successfully.');
          anchor.click();
        });
      } else {
        this.auth.get_doc_download(this.selectedProfile.id, doc.docid).subscribe((res: any) => {
          if (res.error == false) {
            window.open(res.data.url, '_blank');
            this.toastr.success(res.msg || 'Document downloaded successfully.');
          }
        });
      }
    } else {
      if (doc.doctype === "personal") {
        this.auth.get_docDownload(doc.doctype, doc.docid).subscribe((res: any) => {
          if (res.error == false) {
            window.open(res.data.url, '_blank');
            this.toastr.success(res.msg || 'Document downloaded successfully.');
          }
        });
      } else {
        this.auth.get_docIdentityDownload(doc.doctype, doc.country_affiliation, doc.docname).subscribe((res: any) => {
          if (res.error == false) {
            window.open(res.data.url, '_blank');
            this.toastr.success(res.msg || 'Document downloaded successfully.');
          }
        });
      }
    }
  }

  closePreview(): void {
    if (this.previewDocument?.previewUrl) {
      URL.revokeObjectURL(this.previewDocument.previewUrl.toString());
    }
    this.previewDocument = null;
    this.isPreviewOpen = false;
    this.isPreviewLoading = false;
  }

  isContactAccepted(contact: any): boolean {
    return contact.status === 'accepted' || contact.status === 'accepted_by_consumer';
  }
}